<div class="row" style="min-height: 300px;" xmlns="http://www.w3.org/1999/html">
  <div class="col-12">
    <div class="tablewrap">
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">Identifier</p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="identifier"
                   (ngModelChange)="identifierChange($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.name' | translate }}<span class="red">*</span></p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="name"
                   (ngModelChange)="nameChange($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.technique' | translate }}</p>
          <div class="w-100 tr">
            <div ngbDropdown placement="bottom-right">
              <button ngbTooltip="{{ 'lang.globals.technique' | translate }}" placement="top" container="body"
                      class="btn btn-outline-primary" id="dropdownTechniques" ngbDropdownToggle>
                <span class="font-weight-bold mr-1">{{selectedTechnique}}</span>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownTechniques">
                <ng-scrollbar class="scrollDropdownColumnSelect">
                  <button *ngFor="let tech of techniques" ngbDropdownItem (click)="selectedTechnique = tech">
                    {{tech}}
                  </button>
                </ng-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row bb" *ngPermissions="[permissionService.Permission.location_list]">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.location' | translate }}</p>
          <div class="w-100 tr" style="margin-top: -14px;">
            <button class="btn btn-outline-primary" (click)="selectLocation()">
              <i *ngIf="getLocationText() === 'n. def.'; else locationTextElse">
                &#91;{{getLocationText()}}&#093;
              </i>
              <ng-template #locationTextElse>
                {{getLocationText()}}
              </ng-template>
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row bbl">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
        </div>
      </div>
      <div *ngIf="permissionService.hasPermission(permissionService.Permission.visitor_tracker_edit) && editMode" class="row mb-2">
        <div class="col-12">
          <div class="tablewrap">
            <div class="d-flex flex-row bb">
              <div
                class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                <p class="w-100">{{'lang.globals.disabled' | translate}}</p>
                <p class="w-100 tr">
                  <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.visitor_tracker_edit)"
                                    onText="{{ 'lang.globals.yes' | translate }}"
                                    offText="{{ 'lang.globals.no' | translate }}"
                                    [(model)]="tracker.disabled"></sb-toggle-switch>
                </p>
              </div>
            </div>
            <div class="d-flex flex-row bb">
              <div
                class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                <p class="w-100">{{'lang.globals.productive' | translate}}</p>
                <p class="w-100 tr">
                  <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.visitor_tracker_edit)"
                                    onText="{{ 'lang.globals.yes' | translate }}"
                                    offText="{{ 'lang.globals.no' | translate }}"
                                    [(model)]="tracker.productive"></sb-toggle-switch>
                </p>
              </div>
            </div>
            <div class="d-flex flex-row bb">
              <div
                class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                <p class="w-100">{{'lang.globals.online' | translate}}</p>
                <p class="w-100 tr">
                  <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.visitor_tracker_edit)"
                                    onText="{{ 'lang.globals.yes' | translate }}"
                                    offText="{{ 'lang.globals.no' | translate }}"
                                    [model]="!tracker.offline" (modelChange)="tracker.offline = $event"></sb-toggle-switch>
                </p>
              </div>
            </div>
            <div class="d-flex flex-row bb">
              <div
                class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                <p class="w-100">{{'lang.globals.external' | translate}}</p>
                <p class="w-100 tr">
                  <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.visitor_tracker_edit)"
                                    onText="{{ 'lang.globals.yes' | translate }}"
                                    offText="{{ 'lang.globals.no' | translate }}"
                                    [(model)]="tracker.external"></sb-toggle-switch>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row bbl">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
        </div>
      </div>
      <div class="d-flex flex-row">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100 tr"></p>
          <p class="w-100 tr">
            <button class="btn btn-primary mr-2"
                    (click)="ok()"
                    [disabled]="name?.length < 1 || name?.trim()?.length < 1">{{ 'lang.globals.ok' | translate }}</button>
            <button class="btn btn-secondary"
                    (click)="cancel()">{{ 'lang.globals.cancel' | translate }}</button>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
